document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('vsRecoveryModal');
  const overlay = document.getElementById('vsRecoveryOverlay');
  const closeBtn = document.getElementById('vsRecoveryClose');
  const declineBtn = document.getElementById('vsRecoveryDeclineBtn');
  const copyBtn = document.getElementById('vsRecoveryCopyBtn');
  const toast = document.getElementById('vsRecoveryToast');
  const toastClaimBtn = document.getElementById('vsToastClaimBtn');
  const toastCloseBtn = document.getElementById('vsToastCloseBtn');
  const cartListContainer = document.getElementById('vsRecoveryCartList');
  const countdownElem = document.getElementById('vsRecoveryCountdown');

  let originalTitle = document.title;
  let cartData = null;
  let hasTriggered = false;
  let isTabSwapped = false;
  let timerInterval = null;

  // 1. Fetch live cart items from Shopify
  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      if (res.ok) {
        cartData = await res.json();
        return cartData;
      }
    } catch (err) {
      console.warn('[VS Recovery] Failed to fetch cart:', err);
    }
    return null;
  }

  // Render cart items inside modal
  function renderCartItems(cart) {
    if (!cartListContainer) return;
    if (!cart || !cart.items || cart.items.length === 0) {
      cartListContainer.innerHTML = '<div class="vs-cart-item-placeholder">Your cart is empty</div>';
      return;
    }

    let html = '';
    cart.items.forEach(function (item) {
      const img = item.image || item.featured_image?.url || '';
      const title = item.title || item.product_title || 'Item';
      const price = item.final_line_price ? (item.final_line_price / 100).toLocaleString('en-IN') : '';
      
      html += `
        <div class="vs-cart-item-row">
          ${img ? `<img src="${img}" alt="${title}">` : ''}
          <div class="vs-cart-item-details">
            <h4 class="vs-cart-item-title">${title}</h4>
            <div class="vs-cart-item-price">Qty: ${item.quantity} &bull; ₹${price}</div>
          </div>
        </div>
      `;
    });

    cartListContainer.innerHTML = html;
  }

  // 2. Timer countdown (15 mins)
  function startCountdown() {
    if (timerInterval) clearInterval(timerInterval);
    let secondsLeft = 15 * 60; // 15 minutes

    function updateDisplay() {
      if (!countdownElem) return;
      const m = Math.floor(secondsLeft / 60);
      const s = secondsLeft % 60;
      countdownElem.textContent = `${m < 10 ? '0' : ''}${m}:${s < 10 ? '0' : ''}${s}`;
      if (secondsLeft > 0) {
        secondsLeft--;
      } else {
        clearInterval(timerInterval);
      }
    }

    updateDisplay();
    timerInterval = setInterval(updateDisplay, 1000);
  }

  // 3. Open Modal
  async function openRecoveryModal() {
    if (hasTriggered && sessionStorage.getItem('vsRecoveryClosed')) return;
    const cart = await fetchCart();
    if (!cart || cart.item_count === 0) return;

    renderCartItems(cart);
    startCountdown();

    if (modal && overlay) {
      modal.classList.add('active');
      overlay.classList.add('active');
      hasTriggered = true;
    }
  }

  function closeRecoveryModal() {
    if (modal && overlay) {
      modal.classList.remove('active');
      overlay.classList.remove('active');
      sessionStorage.setItem('vsRecoveryClosed', 'true');

      // Show evident bottom toast after modal is closed
      if (toast && cartData && cartData.item_count > 0) {
        toast.classList.add('active');
      }
    }
  }

  // 4. Tab Switcher & Title Alert
  document.addEventListener('visibilitychange', async function () {
    if (document.visibilityState === 'hidden') {
      const cart = cartData || (await fetchCart());
      if (cart && cart.item_count > 0) {
        isTabSwapped = true;
        document.title = '⚡ WAIT! 5% OFF in your cart! (Up to ₹6,000) 🛒';
      }
    } else if (document.visibilityState === 'visible') {
      document.title = originalTitle;
      if (isTabSwapped) {
        isTabSwapped = false;
        openRecoveryModal();
      }
    }
  });

  // Window blur fallback for tab switch
  window.addEventListener('blur', async function () {
    const cart = cartData || (await fetchCart());
    if (cart && cart.item_count > 0) {
      isTabSwapped = true;
      document.title = '⚡ WAIT! 5% OFF in your cart! (Up to ₹6,000) 🛒';
    }
  });

  window.addEventListener('focus', function () {
    document.title = originalTitle;
    if (isTabSwapped) {
      isTabSwapped = false;
      openRecoveryModal();
    }
  });

  // 5. Exit Intent (Mouse move towards top)
  document.addEventListener('mouseleave', function (e) {
    if (e.clientY <= 10) {
      openRecoveryModal();
    }
  });

  // Event Listeners
  if (closeBtn) closeBtn.addEventListener('click', closeRecoveryModal);
  if (declineBtn) declineBtn.addEventListener('click', closeRecoveryModal);
  if (overlay) overlay.addEventListener('click', closeRecoveryModal);

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText('SAVE5').then(function () {
        copyBtn.textContent = 'COPIED!';
        setTimeout(function () {
          copyBtn.textContent = 'COPY CODE';
        }, 3000);
      });
    });
  }

  if (toastClaimBtn) {
    toastClaimBtn.addEventListener('click', function () {
      window.location.href = '/discount/SAVE5?redirect=/checkout';
    });
  }

  if (toastCloseBtn) {
    toastCloseBtn.addEventListener('click', function () {
      if (toast) toast.classList.remove('active');
    });
  }

  // Pre-fetch cart status
  fetchCart();
});
